export const NATIONAL_ID_REQUIRED_MESSAGE = "National ID Number is required for self-investment delegates.";

const IN_HOUSE_DEAL_TYPES = ["In-house", "LVT In-House", "Learning Journey"];

const NATIONAL_ID_FIELD_KEYS = [
    "nationalIdNumber",
    "nationalIDNumber",
    "nationalIdNo",
    "nationalIDNo",
    "nationalId",
    "nationalID",
    "national_id_number",
    "national_id",
    "nationalIdentificationNumber",
    "nationalIdentityNumber",
    "customerNationalIdNumber",
    "delegateNationalIdNumber",
    "profileNationalIdNumber",
    "identityNumber",
    "idNumber",
    "tcKimlikNo",
    "tcKimlikNumber",
    "tckn",
];

export const isTruthySelfInvestment = (value) =>
    value === true || value === 1 || value === "1" || value === "Yes" || value === "yes" || value === "true";

export const getNationalIdNumber = (...sources) => {
    for (const source of sources) {
        if (!source) continue;

        for (const key of NATIONAL_ID_FIELD_KEYS) {
            if (source[key] !== undefined && source[key] !== null && source[key] !== "") {
                return source[key];
            }
        }
    }

    return "";
};

export const isNationalIdRequiredForSelfInvestmentDeal = ({
    activityType,
    dealCampaignType,
    isSelfInvestment,
    status,
}) => {
    const isInvoiceRequisition = !activityType || activityType === "Invoice Requisition";
    const isWonDeal = !status || status === "Won";

    return (
        isInvoiceRequisition &&
        isWonDeal &&
        !IN_HOUSE_DEAL_TYPES.includes(dealCampaignType) &&
        isTruthySelfInvestment(isSelfInvestment)
    );
};
